import { Box, SxProps } from '@mui/material'

interface LetterCounterProps {
  value: string
  maxLengthVal: number
}

const style: SxProps = {
  color: 'text.secondary',
  fontSize: '13px',
  textAlign: 'right',
}

export default function LetterCounter({ value, maxLengthVal }: LetterCounterProps): JSX.Element {
  return (
    <Box sx={style}>
      {value.length}/{maxLengthVal}
    </Box>
  )
}
